import { Injectable } from '@angular/core';
import {
  IGetSurveyResponse,
  INewsCategory,
  INewsDetails,
  IPayrollDeductionsResponse,
  IPayrollResponse,
  IPDFResource,
  IPostSurveyResponse,
  IQuestion
} from '@models';
import { IEmployee } from '@shared/models/main.interfaces';
import { HttpService } from '../core/http.service';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {
  constructor(private httpService: HttpService) {}

  public getNews(page: number, pageSize: number, categoryId = 0): Promise<{ Records: INewsDetails[] }> {
    const categoryParam = !!categoryId ? `&categoryId=${categoryId}` : '';
    return this.httpService.http_get({
      param: `?page=${page}&pageSize=${pageSize}${categoryParam}`,
      endpoint: null,
      api: 'News',
      needToken: true
    }) as Promise<{ Records: INewsDetails[] }>;
  }

  public getCategories(): Promise<INewsCategory[]> {
    return this.httpService.http_get({
      endpoint: 'categories',
      api: 'News',
      needToken: true
    }) as Promise<INewsCategory[]>;
  }

  public getPDFs(page: number, pageSize = 10): Promise<{ Records: IPDFResource[] }> {
    return this.httpService.http_get({
      param: `?page=${page}&pageSize=${pageSize}`,
      endpoint: null,
      api: 'Published',
      needToken: true
    }) as Promise<{ Records: IPDFResource[] }>;
  }

  public getEmployee(): Promise<IEmployee> {
    return this.httpService.http_get({
      endpoint: null,
      api: 'Employees',
      needToken: true
    }) as Promise<IEmployee>;
  }

  //endpoint for Payroll
  public getPayRoll(): Promise<IPayrollResponse> {
    return this.httpService.http_get({
      endpoint: 'payroll',
      api: 'Employees',
      needToken: true
    }) as Promise<IPayrollResponse>;
  }

  //endpoint for PayrollDeduction
  public getPayRollDeductions(idNomina: number): Promise<IPayrollDeductionsResponse> {
    return this.httpService.http_get({
      endpoint: `payrollDeductions?idNomina=${idNomina}`,
      api: 'Employees',
      needToken: true
    }) as Promise<IPayrollDeductionsResponse>;
  }

  public getSurveys(): Promise<IGetSurveyResponse> {
    return this.httpService.http_get({
      param: `?page=${1}&pageSize=${15}`,
      api: 'Survey',
      needToken: true
    }) as Promise<IGetSurveyResponse>;
  }
  public getSurveyById(id: number): Promise<IQuestion[]> {
    return this.httpService.http_get({
      api: `Survey/${id}/questions`,
      needToken: true
    }) as Promise<IQuestion[]>;
  }
  public postSurveys(survey): Promise<IPostSurveyResponse> {
    return this.httpService.http_post({
      endpoint: null,
      body: JSON.stringify(survey),
      api: 'Survey',
      needToken: true
    }) as Promise<IPostSurveyResponse>;
  }
  public changePassword<T>(body): Promise<T> {
    return this.httpService.http_post({
      endpoint: 'changePassword',
      body: body,
      api: 'Users',
      needToken: true
    }) as Promise<T>;
  }
}
